module.exports = __webpack_public_path__ + "img/fashion_105.b95b876d.jpg";